/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';
import { Simulate } from 'react-dom/test-utils';

export const EyeIcon: FC<IconType> = (props) => {
  const { width, height, color, toggle } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.34479 9.16308C2.20618 8.96491 2.13184 8.72892 2.13184 8.48708C2.13184 8.24524 2.20618 8.00925 2.34479 7.81108C3.24365 6.53851 5.45679 3.91565 8.41736 3.91565C11.3779 3.91565 13.5911 6.53851 14.4899 7.81108C14.6285 8.00925 14.7029 8.24524 14.7029 8.48708C14.7029 8.72892 14.6285 8.96491 14.4899 9.16308C13.5911 10.4356 11.3779 13.0585 8.41736 13.0585C5.45679 13.0585 3.24365 10.4356 2.34479 9.16308Z"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M8.41755 10.7727C9.67992 10.7727 10.7033 9.74937 10.7033 8.48701C10.7033 7.22464 9.67992 6.20129 8.41755 6.20129C7.15519 6.20129 6.13184 7.22464 6.13184 8.48701C6.13184 9.74937 7.15519 10.7727 8.41755 10.7727Z"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      {toggle && (
        <path
          d="M2.70312 14.2014L14.1317 2.77283"
          stroke={color}
          strokeWidth="1.37143"
          strokeMiterlimit={10}
          strokeLinecap="square"
        />
      )}
    </svg>
  );
};
